import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore';

// Import initializeFirestore and persistence-related functions for modular SDK
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager, // For multi-tab support, or use persistentSingleTabManager for single tab
  // persistentSingleTabManager,
  memoryLocalCache
} from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7RY5N0Og5rTec8PfyGy9Uvt5rtFCGjus",
  authDomain: "track-assetz.firebaseapp.com",
  projectId: "track-assetz",
  storageBucket: "track-assetz.firebasestorage.app",
  messagingSenderId: "73718604437",
  appId: "1:73718604437:web:8e44f543f8c639cdf7b19c",
  measurementId: "G-ZDEK7BXY90"
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  app = initializeApp(firebaseConfig, "mf-nav-checker");
}



export const auth = getAuth(app);

let firstore_db; // Declare db outside to be accessible after try/catch
try {
  // Use initializeFirestore to configure persistence from the start.
  // This example enables multi-tab IndexedDB persistence.
  // For single-tab persistence (default for persistentLocalCache if no tabManager is specified),
  // you could use: firstore_db = initializeFirestore(app, { localCache: persistentLocalCache({}) });
  
  firstore_db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager() // This enables multi-tab persistence
    })
  });
  
  console.log("LOG: Firestore persistence enabled successfully!");
} catch (err: any) { // Add ': any' for TypeScript if 'err' is implicitly 'unknown'
  console.log("LOG: FAILED TO ENABLE FIRESTORE PERSISTENCE", err);
  if (err.code === 'failed-precondition') {
      // This happens if persistence can only be enabled in one tab at a time,
      // and another tab is already using it (e.g., if you tried to use
      // single-tab persistence, or if a different tab is already using
      // single-tab persistence and you're trying to start multi-tab).
      console.warn("Firestore persistence failed: Another tab is already open or configured for single-tab persistence.");
  } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the features required
      // to enable IndexedDB persistence.
      console.warn("Firestore persistence failed: Browser does not support IndexedDB.");
  }
  // If persistence fails, we still want a functional Firestore instance,
  // so we fall back to a memory-only cache.
  firstore_db = initializeFirestore(app, { localCache: memoryLocalCache() }); // Ensure db is initialized even if persistence fails
  console.warn("Falling back to memory-only Firestore cache.");
}

export const db = firstore_db; // Export the initialized db instance
// export const db = getFirestore(app);